module.exports = (__webpack_public_path__ || '') + "static/images/apple-touch-icon-180x180-6e9a800047bfb5d92907cb3e490374ff.png";